import React, { useRef, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import {disableAudio, enableAudio, initChat, postMessage} from "../../slice/chat.slice";
import {MicIcon, SendIcon} from "./icons";
import {Config} from "../../config";
import LoadingIndicator from "./loading.indicator";

export default function MessageInput() {
    const dispatch = useDispatch();
    const audioEnabled = useSelector((state) => state.chat.audioEnabled);
    const withAudio = useSelector((state) => state.chat.withAudio);
    const isOpen = useSelector((state) => state.chat.isOpen);
    const loading = useSelector((state) => state.chat.loading);
    const config = Config.getInstance();

    const [expanded, setExpanded] = useState(false);
    const MAX_LENGTH_TRIGGER = 30; // Amount of characters to trigger expansion

    const handleSendMessage = (event) => {
        event.preventDefault();

        const value = inputRef.current?.value?.trim();
        if (value?.length) {
            dispatch(postMessage({ message: value }));
            inputRef.current.value = "";
            setExpanded(false);
        }
    };
    const inputRef = useRef(null);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            handleSendMessage(event);
        }
    };

    const handleInputChange = (event) => {
        const value = event.target.value;
        if (value.length > MAX_LENGTH_TRIGGER || value.includes("\n")) {
            setExpanded(true);
        } else {
            setExpanded(false);
        }
    };

    const handleAudioToggle = () => {
        if (withAudio) {
            dispatch(disableAudio());
        } else {
            dispatch(enableAudio());
        }
    };

    const handleStartNewSession = async () => {
        dispatch(initChat());
    };

    if (loading) {
        return <LoadingIndicator />;
    }

    if (!isOpen) {
        return (
            <div className="sb-message-input-closed-container">
                <div className="sb-message-input-closed">
                    Chat session is finished
                </div>
                <button
                    className="sb-start-new-session-btn"
                    onClick={handleStartNewSession}
                    aria-label="Start new session"
                >
                    Start new session
                </button>
            </div>
        );
    }

    return (
        <div className="sb-chat--footer">
            <form onSubmit={handleSendMessage} className={'sb-chat--footer_grid'}>
                <textarea
                    className={`sb-chat--footer_input ${expanded ? "expanded" : ""}`}
                    maxLength={500}
                    ref={inputRef}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                    placeholder="Type a message..."
                />
                <div className="sb-chat--footer_btn-bar">
                    <div className="sb-chat--footer_btn-bar--row">
                        {audioEnabled &&
                            <button
                                type="button"
                                className={`sb-chat--button sb-chat--button_audio sb-chat--audio sb-audio-btn ${withAudio ? " active" : ""}`}
                                onClick={handleAudioToggle}
                                aria-label={withAudio ? "Disable audio" : "Enable audio"}
                            >
                                <MicIcon withAudio={withAudio} />
                            </button>
                        }
                        <button className={'sb-chat--button sb-chat--button_send'} type="submit" onClick={handleSendMessage} aria-label="Send">
                            <SendIcon />
                        </button>
                    </div>
                </div>
            </form>

            {config.is_admin && <p className={'p p--secondary p--small'}>
                AI can make mistakes. Please double check important details. <a href='https://simplybook.me/en/policy' target='_blank'>Privacy Policy</a>
            </p>}
        </div>
    );
}